import React, { useEffect, useState } from 'react';
import { Icon, Button } from 'framework7-react';
import PropTypes from 'prop-types';

export const ZoomButtons = props => {
  const minZoom = props.minZoom || 10;
  const maxZoom = props.maxZoom || 100;

  const [zoom, setZoom] = useState(props.initialZoom || 0);

  const canZoomIn = () => zoom < maxZoom;
  const canZoomOut = () => zoom > minZoom;
  const zoomIn = () => changeZoom(zoom < 30 ? 5 : 10);
  const zoomOut = () => changeZoom(zoom <= 30 ? -5 : -10);

  const changeZoom = z => {
    const newZoom = zoom + z;
    if (newZoom >= minZoom && newZoom <= maxZoom) {
      setZoom(zoom + z);
      props.onChange(zoom + z);
    }
  };

  useEffect(() => {
    setZoom(props.initialZoom);
  }, [props.initialZoom]);

  return (
    <div
      className={'flying-toolbar'}
      style={{
        display: 'flex',
        justifyContent: 'center',
        position: props.sticky ? 'sticky' : 'absolute',
        width: '100%',
        bottom: props.botPosition || 50,
        zIndex: 1000,
        opacity: 0.8,
        gap: 6
      }}
    >
      {props.showGridButton && (
        <Button
          small
          fill
          onClick={() => props.onChange(minZoom)}
          disabled={!canZoomOut()}
          color={'black'}
          style={{
            width: 30,
            height: 30,
            padding: '1px 0',
            textOverflow: 'clip'
          }}
        >
          <Icon material="view_module" />
        </Button>
      )}
      <Button
        small
        fill
        onClick={zoomOut}
        disabled={!canZoomOut()}
        color={'black'}
        style={{
          width: 30,
          height: 30,
          padding: '1px 5px',
          textOverflow: 'clip'
        }}
      >
        <Icon material="zoom_out" />
      </Button>
      <Button
        small
        fill
        onClick={zoomIn}
        disabled={!canZoomIn()}
        color={'black'}
        style={{
          width: 30,
          height: 30,
          padding: '1px 5px',
          textOverflow: 'clip'
        }}
      >
        <Icon material="zoom_in" />
      </Button>
    </div>
  );
};

ZoomButtons.propTypes = {
  onChange: PropTypes.func,
  initialZoom: PropTypes.number,
  botPosition: PropTypes.number,
  minZoom: PropTypes.number,
  maxZoom: PropTypes.number,
  showGridButton: PropTypes.bool,
  sticky: PropTypes.bool
};
